import React from 'react';
import { View } from 'react-native';
import Text from 'design-system/Text';
import { CardView, Spacer, rem } from 'design-system';
import AnalyticsCard from 'design-system/AnalyticsCard';
import useStyles from 'hooks/useStyles';
import createStyleSheets from 'utils/createStyleSheets';
import useColors from 'hooks/useColors';
const StockFinancialInfoCard = ({ title, subTitle, fiscalYear, titleMetrics, leftBarPercent, rightBarPercent, bottomLeftMetrics, bottomRightMetrics, }) => {
    const colors = useColors();
    const styles = useStyles(styleSet);
    return (<View style={styles.mainContainer}>
      <CardView withPadding noMargin>
        <Text Text-14 numberOfLines={1}>
          {title}
        </Text>
        <Spacer h={8}/>
        <Text TextThin-14 numberOfLines={1} Secondary>
          {subTitle}
        </Text>
        <Spacer h={4}/>
        <Text Numbers-16 numberOfLines={1}>
          {titleMetrics}
          <Text TextThin-16 Secondary>
            {' in '}
          </Text>
          <Text NumbersThin-16 Secondary>
            {fiscalYear}
          </Text>
        </Text>

        <Spacer h={12}/>
        <AnalyticsCard rightBarGradientKey="darkPink" leftBarPercent={leftBarPercent} rightBarPercent={rightBarPercent} leftBarColor={colors.elements.brand}/>
        <Spacer h={24}/>

        <View style={styles.row}>
          <View style={styles.container}>
            <Text Numbers-14 centered numberOfLines={1}>
              {bottomLeftMetrics.metrics}
            </Text>
            <Text TextThin-12 centered numberOfLines={1}>
              {bottomLeftMetrics.title}
            </Text>
          </View>
          <View style={styles.container}>
            <Text Numbers-14 centered numberOfLines={1}>
              {bottomRightMetrics.metrics}
            </Text>
            <Text TextThin-12 centered numberOfLines={1}>
              {bottomRightMetrics.title}
            </Text>
          </View>
        </View>
      </CardView>
    </View>);
};
export default StockFinancialInfoCard;
const styleSet = createStyleSheets(() => ({
    mainContainer: {
        flex: 1,
        borderRadius: rem(16),
    },
    container: {
        flex: 1,
    },
    row: {
        flexDirection: 'row',
    },
}));
